import React from "react";
import { Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";

export const ModalConfirmacao = (titulo = 'Confirmação', funcaoExecutada, conteudo = null) => {
    let modal = null;

    modal = Modal.confirm({
        title: titulo,
        icon: <ExclamationCircleFilled />,
        content: conteudo,
        okText: 'Confirmar',
        okType: 'danger',
        cancelText: 'Cancelar',
        centered: true,
        cancelButtonProps: {
            disabled: false,
        },
        async onOk() {
            modal.update({
                cancelButtonProps: {
                    disabled: true,
                },
                okButtonProps: {
                    loading: true
                }
            });

            await funcaoExecutada();
        }
    });
};

export function ModalConfirmacaoBotoesCustomizados({
    titulo,
    conteudo,
    onClickAcao,
    tipoBotaoAcao,
    largura = 600,
    labelBotaoAcao,
    onClickCancelar,
    centralizado = true,
    labelBotaoCancelar = "Cancelar",
    iconModal = <ExclamationCircleFilled />
}) {
    Modal.confirm({
        title: titulo,
        width: largura,
        icon: iconModal,
        content: conteudo,
        onOk: async () => {
            if (onClickAcao) {
                await onClickAcao();
            }
        },
        okType: tipoBotaoAcao,
        okText: labelBotaoAcao,
        centered: centralizado,
        onCancel: onClickCancelar,
        cancelText: labelBotaoCancelar
    });
}
